import { createRouter } from "router5"; 
import loggerPlugin from "router5-plugin-logger";
import browserPlugin from "router5-plugin-browser";
import { routes } from "./routes";

export default function configureRouter(useLoggerPlugin = false) {
    console.log("creating")
    const router = createRouter(routes, { defaultRoute: "base" });
    console.log("creatEd")

    router.usePlugin(browserPlugin({ useHash: true }));

    if (useLoggerPlugin) {
        router.usePlugin(loggerPlugin);
    }

    return router;
}
